import React from "react";
import { FiPlus, FiUsers, FiEye, FiCamera } from "react-icons/fi";
import { FaAddressCard } from "react-icons/fa";

import AdminButton from "../../_shared/ui/AdminButton";

export default function TrombinosHero({ stats, loading, onCreate }) {
  return (
    <section className="relative overflow-hidden rounded-[2rem] border border-indigo-100 bg-gradient-to-br from-indigo-700 via-sky-600 to-cyan-600 p-5 text-white shadow-xl shadow-sky-500/20 dark:border-indigo-500/20 sm:p-7 lg:p-8">
      <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-white/15 blur-3xl" />
      <div className="pointer-events-none absolute bottom-[-80px] left-[30%] h-56 w-56 rounded-full bg-cyan-200/20 blur-3xl" />

      <div className="relative grid gap-6 lg:grid-cols-[1fr_auto] lg:items-end">
        <div>
          <div className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-3 py-1.5 text-xs font-bold uppercase tracking-[0.18em] text-white/90 backdrop-blur">
            <FaAddressCard />
            Trombinoscope
          </div>

          <h1 className="mt-5 max-w-3xl text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
            Gérez les élus municipaux et les profils de la mairie.
          </h1>

          <p className="mt-4 max-w-2xl text-sm leading-7 text-white/85 sm:text-base">
            Créez des fiches claires avec photo, fonction, contact, mandat,
            service rattaché et visibilité sur le site public.
          </p>

          <div className="mt-6 flex flex-wrap gap-3">
            <div className="rounded-2xl border border-white/20 bg-white/10 px-4 py-3 backdrop-blur">
              <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.16em] text-white/70">
                <FiUsers />
                Total
              </div>

              <p className="mt-1 text-2xl font-bold">
                {loading ? "…" : stats.total}
              </p>
            </div>

            <div className="rounded-2xl border border-white/20 bg-white/10 px-4 py-3 backdrop-blur">
              <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.16em] text-white/70">
                <FiEye />
                Visibles
              </div>

              <p className="mt-1 text-2xl font-bold">
                {loading ? "…" : stats.visibleOnPage}
              </p>
            </div>

            <div className="rounded-2xl border border-white/20 bg-white/10 px-4 py-3 backdrop-blur">
              <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.16em] text-white/70">
                <FiCamera />
                Avec photo
              </div>

              <p className="mt-1 text-2xl font-bold">
                {loading ? "…" : stats.withPhotoOnPage}
              </p>
            </div>
          </div>
        </div>

        <div className="flex lg:justify-end">
          <AdminButton
            icon={FiPlus}
            variant="white"
            size="lg"
            onClick={onCreate}
          >
            Nouveau profil
          </AdminButton>
        </div>
      </div>
    </section>
  );
}